<template>
  <div class="section">
    <div class="container">
      <h1 class="title">ສະບາຍດີ, Profile</h1>
    </div>
    <div class="container" style="margin-top: 30px;">
      <div class="columns scrollme">
        <div class="column">
          <table width="30%" class="table ">
            <tr>
              <td class="has-text-right" width="30%">
                ຊື່: 
              </td>
              <td class="shiparea">
                {{ profile.FULLNAME }}
              </td>
            </tr>
            <tr>
              <td class="has-text-right">
                ເບີໂທ:
              </td>
              <td class="shiparea">
                {{ profile.PHONENO }}
              </td>
            </tr>
            <tr>
              <td class="has-text-right">
                username:
              </td>
              <td class="shiparea">
                {{ profile.USERNAME }}
              </td>
            </tr>
            <tr>
              <td class="has-text-right">
                role:
              </td>
              <td class="shiparea">
                {{ profile.ROLE }}
              </td>
            </tr>
            <tr>
              <td class="has-text-right">
                ສາຂາ:
              </td>
              <td class="shiparea">
                {{ profile.BRANCHNAME ? profile.BRANCHNAME : profile.ROLE }}
              </td>
            </tr>
            
          </table>
        </div>
      </div>

    </div>
  </div>
</template>
  
<script>
  import RestAPI from "../RestAPI";
  export default {

    name: "home",
    data() {
      return {
        profile: [],
      };
    },
    methods: {
      
      getProfile(){
        RestAPI.getProfile(this.username)
          .then(res => {
            this.profile = res.data;
            // console.log("profile: " + JSON.stringify(this.profile))
          })
          .catch(error => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      }

    },
    mounted() {
      this.username = this.user.USERNAME;
      this.getProfile();
    }
  };
</script>

<style scoped>
.shiparea {
  padding: 10px 0 10px 0;
}
</style>
